module.exports = __webpack_public_path__ + "img/CS2-4.f6bcdf86.png";